import { Badge, Box, HStack, VStack } from '@chakra-ui/react';
import React from 'react';

import { formatPhoneNumber } from '../../../utils/formatting.utils';
import Divider from '../../Divider';
import { DividerColorScheme } from '../../Divider';
import ImageHandler from '../../ImageHandler';
import Link from '../../Link';
import { Text } from '../../Text';

type RepresentativeFlags = {
  growing: boolean;
  spanish: boolean;
};

interface RepresentativeCardProps {
  image: StaticImageDef | React.ReactElement;
  name: string;
  title?: string;
  location: string;
  distance?: string;
  phone?: string;
  website?: string;
  flags: RepresentativeFlags;
}

const GrowingBadge: React.FC = () => (
  <Badge variant="subtle" colorScheme="yellow">
    We are growing!
  </Badge>
);
const SpanishBadge: React.FC = () => (
  <Badge variant="subtle" colorScheme="orange">
    ¡Hablo español!
  </Badge>
);

const RepresentativeCard: React.FC<RepresentativeCardProps> = ({
  image,
  name,
  title,
  location,
  distance,
  phone,
  website,
  flags,
}) => {
  const formattedPhone = formatPhoneNumber(phone);
  return (
    <HStack padding={2}>
      <Box width={135}>
        <ImageHandler image={image} />
      </Box>
      <VStack width={210} align="start" alignSelf="start">
        <Text lineHeight="normal">
          <Text as="b">{name}</Text>
          <br />
          {title && (
            <>
              <Text as="small">{title}</Text>
              <br />
            </>
          )}
          {location}
        </Text>
        <Text as="small">{distance}</Text>

        {flags.growing && <GrowingBadge />}
        {flags.spanish && <SpanishBadge />}
        <Divider colorScheme={DividerColorScheme.GRAY} />

        <Text lineHeight="normal">
          {formattedPhone && (
            <Link to={`tel:${formattedPhone}`}>{formattedPhone}</Link>
          )}
          <br />
          {website && <Link to={website}>Visit Website</Link>}
        </Text>
      </VStack>
    </HStack>
  );
};

export default RepresentativeCard;
